import request from "@/utils/request.js";

// 网关给护理科研门诊配的路由前缀
const PREFIX = "/nursingClinicService/nrc";

/* ---------------- 门诊方向 ---------------- */
export function directionList(params) {
  return request({ url: `${PREFIX}/direction/list`, method: "get", params });
}

/* ---------------- 专家(用户端可见) ---------------- */
export function expertList(params) {
  return request({ url: `${PREFIX}/expert/list`, method: "get", params });
}

export function expertDetail(id) {
  return request({ url: `${PREFIX}/expert/${id}`, method: "get" });
}

/* ---------------- 号源 ---------------- */
export function slotList(params) {
  return request({ url: `${PREFIX}/slot/list`, method: "get", params });
}

/* ---------------- 订单(用户端) ---------------- */
export function orderCreate(params) {
  return request({ url: `${PREFIX}/order/create`, method: "post", data: params });
}

export function orderPay(params) {
  return request({ url: `${PREFIX}/order/pay`, method: "post", data: params });
}

export function paymentChannels() {
  return request({ url: `${PREFIX}/payment/channels`, method: "get" });
}

export function orderList() {
  return request({ url: `${PREFIX}/order/list`, method: "get" });
}

export function orderDetail(id) {
  return request({ url: `${PREFIX}/order/${id}`, method: "get" });
}

// 支付成功后补填/修改咨询留言和上传稿件
export function updateOrderExtra(params) {
  return request({ url: `${PREFIX}/order/updateExtra`, method: "post", data: params });
}

/* ---------------- 转介绍 ---------------- */
export function myReferralCode() {
  return request({ url: `${PREFIX}/referral/my/code`, method: "get" });
}

export function referralVisit(params) {
  return request({ url: `${PREFIX}/referral/share/visit`, method: "post", data: params });
}

export function referralBind(params) {
  return request({ url: `${PREFIX}/referral/relation/bind`, method: "post", data: params });
}

export function myReferralRewards(params) {
  return request({ url: `${PREFIX}/referral/my/reward/list`, method: "get", params });
}

export function myReferralSummary() {
  return request({ url: `${PREFIX}/referral/my/reward/summary`, method: "get" });
}
